import { OptionalFeature } from "../../../../base/domain/drawing";
import { IGroupAlertBehavior } from "./IGroupAlertBehavior";

export class GroupAlertBehavior extends OptionalFeature {
  constructor(
    isEnable: boolean   = false,
    public name: string = ""
  ) {
    super(isEnable);
  }

  clone(): GroupAlertBehavior {
    return new GroupAlertBehavior(this.isEnable, this.name);
  }

  static from(source: IGroupAlertBehavior): GroupAlertBehavior {
    return new GroupAlertBehavior(source.isEnable, source.name);
  }

  static to(source: GroupAlertBehavior): IGroupAlertBehavior {
    return {
      isEnable: source.isEnable,
      name: source.name,
    };
  }
}
